import type { SelectFieldOption } from "@adrekic/fieldsjson"
import { Menu, type MenuSelectGroupProps } from "@overmap-ai/blocks"
import { normalizeFieldOptions } from "@overmap-ai/forms"
import { memo, useMemo } from "react"

import { SelectItemTemplate } from "../MenuGroups/constants"

export type SelectFieldOptionSelectGroupProps = MenuSelectGroupProps<string> & {
	selectFieldOptions: SelectFieldOption[]
}

export const SelectFieldOptionSelectGroup = memo<SelectFieldOptionSelectGroupProps>((props) => {
	const { ref, selectFieldOptions, ...rest } = props

	const normalizedOptions = useMemo(() => normalizeFieldOptions(selectFieldOptions), [selectFieldOptions])

	return (
		<Menu.SelectGroup<string> ref={ref} {...rest}>
			{normalizedOptions.map((selectFieldOption) => (
				<SelectItemTemplate<string> key={selectFieldOption.value} value={selectFieldOption.value}>
					<span className="truncate">{selectFieldOption.label}</span>
				</SelectItemTemplate>
			))}
		</Menu.SelectGroup>
	)
})
SelectFieldOptionSelectGroup.displayName = "SelectFieldOptionSelectGroup"
